import { createAction } from 'redux-actions';
export const FILL_CHECKIN_ORDER = 'FILL_CHECKIN_ORDER';
export const SET_CHECKIN_ORDER = 'SET_CHECKIN_ORDER';
export const setCheckinOrder = createAction(SET_CHECKIN_ORDER);
export const fillCheckinOrder = createAction(FILL_CHECKIN_ORDER);
